<template>
  <div class="app-sticky-cart" v-if="!isElementInViewport" @click="scrollToCart()" aria-hidden="true">
    <div class="sticky-cart--left">
      <div class="cart-icon">
        <img src="files/flash/images/svg-icons/cart.svg" alt="cart">
      </div>
      <div class="down-icon">
        <img src="files/flash/images/svg-icons/arrowd-yellow.svg" alt="scroll-down">
      </div>
    </div>
    <div class="sticky-cart--right">
      <div class="price">
        <div class="price--amount" >{{priceWithoutEuro(fee)}}</div>
        <strong class="price--label">&nbsp;&euro; mtl.</strong>
      </div>
    </div>
  </div>
</template>
<script>

import price from '@/mixins/formatters/price'
import Integer from 'vuelidate/lib/validators/integer'

export default {
  name: 'StickyCart',
  mixins: [price],
  props: {
    fee: {
      type: Integer,
      default: 0
    }
  },
  data () {
    return {
      isElementInViewport: false
    }
  },
  mounted () {
    window.addEventListener('scroll', this.checkVisibility)
    window.addEventListener('resize', this.checkVisibility)
    // Check visibility on page load
    this.checkVisibility()
  },
  computed: {},
  methods: {
    scrollToCart () {
      const targetElement = document.getElementById('cart-sidebar')
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    },
    checkVisibility () {
      const targetElement = document.getElementById('cart-sidebar')
      if (!targetElement) return

      const screenSize = window.innerWidth
      if (screenSize >= 1152) {
        this.isElementInViewport = true
        return
      }

      // Check if element is in viewport
      const rect = targetElement.getBoundingClientRect()
      this.isElementInViewport = (rect.top + 100) < window.innerHeight
    }
  },
  beforeDestroy () {
    // Remove event listeners when component is destroyed
    window.removeEventListener('scroll', this.checkVisibility)
    window.removeEventListener('resize', this.checkVisibility)
  }
}
</script>
